import React, { useMemo } from 'react';
import { observer } from 'mobx-react';
import { CADGap, CADSidebarWidth } from 'styles/constants';
import { ButtonWithDropdown, Icon } from 'components';
import { subscriptionStatusObservable } from 'core/client';
import { AnnotationIcon } from 'icons';
import { themes } from 'styles/themes/wikifactoryNew';
import { useContextManager } from 'apps/context/hooks';
import { renderCustomIcon } from 'utils/jsxUtils';
import { useGetElementInfo } from 'hooks/useGetElementInfo';
import { useCADManager } from 'hooks';
import {
  CADButtonWrapper,
  EyeWrapper,
  OperatorWrapper,
} from './CADButtonWrapper';

export const annotationId = 'CADPage-annotationWrapper';

export const AnnotationButton = observer(() => {
  const {
    viewerControl,
    showAnnotationsEyes,
    toggleAnnotationPanel,
    isActiveAnnotation,
    handleClickAnnotationEye,
  } = useCADManager();
  const contextManager = useContextManager();
  const { top } = useGetElementInfo(`#${annotationId}`);

  const { viewer } = viewerControl;

  const { sectionManager, isDiffing, selectionManager } = viewer || {};

  const tooltip = useMemo(() => {
    if (
      !selectionManager?.IsSelectionModeLink() &&
      contextManager.annotationsAvailable
    ) {
      return 'Annotate';
    }

    if (selectionManager?.IsSelectionModeLink()) {
      return 'Annotating...';
    }

    return 'Sign In to Annotate';
  }, [selectionManager, contextManager]);

  const isVisibleAnnotation =
    !isDiffing &&
    contextManager.annotationsAvailable &&
    subscriptionStatusObservable.status === 'connected';

  return (
    <CADButtonWrapper id={annotationId} isActive={isActiveAnnotation}>
      <OperatorWrapper
        isActive={isActiveAnnotation}
        className={`${showAnnotationsEyes ? '' : 'rounded'}`}
      >
        <ButtonWithDropdown
          renderIcon={isHover =>
            renderCustomIcon(AnnotationIcon, {
              isHover,
              isActive: isActiveAnnotation,
              activeFillColor: themes.color.wfBlue,
            })
          }
          tooltip={tooltip}
          data-testid='CADPage-annotationIcon'
          onClick={() => toggleAnnotationPanel()}
          isActive={isActiveAnnotation}
          isVisible={isVisibleAnnotation}
          hasDropdown={false}
          borderRight='none'
          groupDropdownProps={{
            style: {
              position: 'fixed',
              top,
              left: CADSidebarWidth + CADGap,
              border: 'none',
              boxShadow: `0px 4px 15px 0px ${themes.color.wfGrey350}`,
            },
          }}
          style={{
            padding: CADGap,
            borderRadius: '50%',
          }}
          dropdownDirection='right'
          isDisabled={
            sectionManager.IsRunning() ||
            !contextManager.annotationsAvailable ||
            subscriptionStatusObservable.status === 'disconnected'
          }
        />
      </OperatorWrapper>

      {showAnnotationsEyes && (
        <EyeWrapper
          onClick={handleClickAnnotationEye}
          className=' hover:rounded-br hover:rounded-bl'
        >
          <Icon
            size='default'
            name={viewerControl.viewer.notePad.visible ? 'view_off' : 'view'}
          />
        </EyeWrapper>
      )}
    </CADButtonWrapper>
  );
});
